// @react
import React from 'react'
// @libraries
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
// @components
import Grid from '@bit/atd.web.grid'
import colors from '@bit/atd.web.colors'
import Button from '@bit/atd.web.button'
import Icon from '@bit/atd.web.icons'
// @utils
import Helper from 'utils/Helper.class'
import parseHTML, {
  domToReact,
  HTMLReactParserOptions,
} from 'html-react-parser'
import { Element } from 'domhandler/lib/node'
import TextLink from '@bit/atd.web.text-link/dist/TextLink'

type PropTypes = {
  amount: number
  title: string
  description: string
  link: string
}

const useStyles = makeStyles(() =>
  createStyles({
    leftBlock: {},
    title: {
      color: colors.black,
      fontSize: '14px',
      maxWidth: '300px',
      '& > h6': {
        paddingBottom: '3px',
      },
    },
    amount: {
      color: colors.black,
      fontWeight: 600,
      fontSize: '40px',
      marginRight: '8px',
      lineHeight: 1,
    },
    linkText: {
      fontWeight: 500,
    },
    linkIcon: {
      width: '16px !important',
      marginLeft: '6px',
      color: colors.ctaPrimary,
    },
    description: {
      marginTop: '16px',
    },
  }),
)

/**
 *
 * @param props
 * @constructor
 */
const MetaInfo = (props: PropTypes) => {
  /******************************************
   * PROPS
   ******************************************/

  const { amount, title, description, link } = props

  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()

  /******************************************
   * RENDER
   ******************************************/
  // @todo we should begin collecting dom parsers into a global filter set like this
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs) {
        const { name, attribs, children } = domNode
        if (name === 'a') {
          return (
            <TextLink href={attribs.href}>
              {domToReact(children, options)}
            </TextLink>
          )
        }
      }
    },
  }

  return (
    <>
      <Grid container justify="space-between" alignItems="flex-end">
        <Grid item className={classes.leftBlock}>
          <Grid container alignItems="flex-end">
            <Grid item>
              <Typography
                className={classes.amount}
                variant="h3"
                component={'span'}
              >
                {Helper.formatThousandsNoRounding(amount, 0)}
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                className={classes.title}
                variant="subtitle2"
                component={'h3'}
              >
                {title}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Button size={'small'} variant="tertiary" href={link}>
            <Typography
              className={classes.linkText}
              variant="subtitle2"
              component={'span'}
            >
              View All
            </Typography>
            <Icon glyph="arrow-right" className={classes.linkIcon} size={16} />
          </Button>
        </Grid>
      </Grid>

      <Grid className={classes.description}>
        <Typography variant="body1" component={'p'}>
          {parseHTML(description, options)}
        </Typography>
      </Grid>
    </>
  )
}

export default MetaInfo
